<template>
  <p>{{ profileSummary }}</p>
</template>

<script>
export default {
  name: "ProfileSummary",
  props: ["profileSummary"],
};
</script>

<style></style>
